import EncryptionEnvelopeSchemaJson from './EncryptionEnvelop.schema.json';
import MessageSchemaJson from './Message.schema.json';

export const EncryptionEnvelopeSchema = EncryptionEnvelopeSchemaJson;
export const MessageSchema = MessageSchemaJson;
